import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const NOTIFICATIONS_STORE_NAME = 'notifications'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
